const messages = {
  cs: {
    projectTitle: 'Učíme.se',
    login: 'Přihlášení',
    loginAction: 'Přihlásit',
    email: 'E-mail',
    name: 'Jméno',
    close: 'Zavřít',
    create: 'Vytvořit',
    refresh: 'Obnovit',
    error: 'Vyskytla se chyba, zkuste později.',
    registration: 'Registrace učitele',
    registrationAction: 'Registrovat',
    moveBack: 'Zpět na',
    nameSurname: 'Jméno a příjmení',
    school: 'Název školy',
    send: 'Odeslat',
    fillName: 'Vyplň jméno a příjmení',
    password: 'Heslo',
    introEntry: 'Potvrdit',
    userNotExist: 'Uživatel neexistuje',
    noAccount: 'Nemáte ještě účet?',
    alertInvalidPassword: 'Nesprávné heslo',
    passwordValidation: 'Heslo je příliš krátké, musí obsahovat alespoň 8 znaků',
    files: 'Soubory',
    filesAdd: 'Nahrát soubor',
    filesUrl: 'Odkazy',
    filesAddUrl: '+ přidat odkaz (Youtube, Google dokumenty, ...)',
    filesFillUrl: 'Vyplňte URL adresu odkazu',
    filesMaxSize: 'Maximální velikost souboru je 10MB',
    filesAlertPdf: 'Zatím podporujeme pouze obrázkové a PDF formáty. Soubory lze žákům během vyučování živě promítat.',
    filetypeNotAllowed: 'Tento typ souboru zatím není podporován',
    fileUploadFailed: 'Nahrávání souboru selhalo.',
    emailRequired: 'E-mail je povinný',
    emailNotExist: 'Účet s tímto emailem neexistuje',
    emailValid: 'E-mail musí být v platném formátu',
    emailRegistred: 'Email je již zaregistrován',
    conditions: 'Pro pokračování je nutný souhlas s podmínkami.',
    conditionsButtonAgree: 'Souhlasím s',
    conditionsButtonCond: 'obchodními podmínkami',
    conditionsLink: 'https://uploads-ssl.webflow.com/5e823696f1510536760ddea1/5e8348dd35019b6937c74a41_Obchodni%CC%81%20podmi%CC%81nky.pdf',
    futureEvents: 'Naplánované',
    forgotPassword: 'Zapomenuté heslo',
    forgotPasswordText: 'Odkaz pro obnovení hesla naleznete v emailu.',
    forgotPasswordLogin: 'Nepamatujete si heslo?',
    forgotPasswordQuestion: 'Zapomněli jste heslo?',
    lessonTitle: 'Vyučování',
    lessonList: 'Seznam vyučování',
    lessonStart: 'Zahájit výuku',
    lessonEmpty: 'Momentálně nemáte<br>naplánovanou žádnou výuku',
    lessonDialogTitle: 'Tvorba online výuky',
    lessonDialogPlaceholder: 'Název výuky (např. Dějepis)',
    lessonDialogDate: 'Datum',
    lessonDialogTime: 'Čas zahájení',
    lessonDialogTimeHint: 'Ve formátu HH:mm',
    lessonDialogStudents: 'E-maily žáků (oddělené čárkou)',
    lessonDialogStudentsHint: 'Maximálně 35 žáků',
    lessonDialogAbout: 'Vytvořením výuky se žákům automaticky odešle informační email.',
    lessonDialogAboutLink: 'Po tvorbě výuky získáte odkaz, který se svými žáky sami nasdílíte.',
    lessonCreate: 'Vytvořit výuku',
    lessonHistory: 'Historie',
    alertLessonTitle: 'Vyplňte název výuky',
    alertLessonDate: 'Vyplňte datum',
    alertLessonTime: 'Vyplňte čas',
    alertLessonEmail: 'Vyplňte emaily',
    online: 'online',
    offline: 'offline',
    activeInVideo: 'aktivní ve videu',
    videoEnd: 'Vrátit',
    videoConnect: 'Vyvolat',
    statusOnline: 'Zatím není nikdo online',
    statusOffline: '<strong>Všichni jsou online!</strong><br />Tak tomu se říká morálka!',
    buttonTextLessonStart: 'Zahájit vyučování',
    buttonTextLessonEnd: 'Ukončit vyučování',
    buttonTextEnd: 'Konec',
    students: 'Žáci',
    cameraOff: 'Video je k dispozici jen během výuky',
    keynoteOff: 'Momentálně zde není žádná prezentace',
    waveHand: '👋 Zvednout ruku',
    wavingHand: '👋 Zvednutá ruka',
    teacherMulti: 'Učitel/ka',
    notSelected: '(bez prezentace)',
    linkUnavaliable: 'Bylo dosaženo limitu připojených žáků',
    done: 'Dokončit',
    continue: 'Pokračovat',
    enter: 'Vstoupit',
    filesToBeUsed: 'Materiály, se kterými budete pracovat',
    optional: '(Nepovinné - lze doplnit později)',
    browserInfo: 'Pro plnou funkcionalitu Učíme.se prosím používejte jeden z následujících prohlížečů: <a href="https://www.google.com/intl/cs_CZ/chrome/" target="_blank"><strong>Chrome</strong><a/>, Firefox nebo Opera.',
    support: 'Podpora',
    recycle: 'Použít znovu',
    deteleTitle: 'Smazat výuku',
    deteleSubtitle: 'Po potvrzení dojde k úplnému smazání. Žáci již k této výuce nebudou mít přístup.',
    dialogCancel: 'Zrušit',
    dialogDelete: 'Smazat',
    toggleVideo: 'Vypnout / zapnout video',
    toggleAudio: 'Vypnout / zapnout zvuk',
    download: 'Stáhnout',
    inYourHands: 'Je to ve vašich rukou',
    whatCanWeImprove: 'Co můžeme do příště zlepšit?',
    howDoYouRate: 'Jak hodnotíte tuto výuku?',
    howDoYouRateTest: 'Jak zatím hodnotíte Učíme.se?',
    justFinishedLesson: 'Právě jsme s mými žáky absolvovali hodinu přes Učíme se. Kolegové, doporučuji vyzkousět!',
    toolForLearning: 'Nástroj pro online výuku',
    shareViaEmail: 'Sdílet e-mailem',
    shareViaFacebook: 'Sdílet na Facebooku',
    helpToShare: 'Pomožte nám Učíme.se dostat mezi své kolegy',
    yourMessage: 'Vaše zpráva',
    somethingWentWrong: 'Žádná sláva',
    fineBut: 'Fajn, ale...',
    amazing: 'Super',
    viewWindowType1: 'Poměr oken 1:1',
    viewWindowType2: 'Velké video',
    viewWindowType3: 'Velká prezentace',
    openLink: 'Otevřít odkaz',
    chat: 'Chat',
    shareScreen: 'Sdílení obrazovky',
    media: 'Materiály',
    keynotePrev: 'Předchozí strana',
    keynoteNext: 'Další strana',
    studentInvite: 'Odkaz na výuku',
    linkCopySubheadline: 'Přes tento odkaz se Vaši žáci dostanou k online výuce.',
    copyLink: 'Zkopírovat odkaz',
    copiedLink: 'Odkaz byl zkopírován',
    copyLinkExtended: 'Zkopírovat odkaz na výuku',
    voiceless: 'Bez mikrofonu',
    noMicButHears: 'Žák však může výuku pozorovat',
    iWillInvite: 'Žáky pozvu vlastní cestou (WhatsApp, Google Classroom, ...)',
    howToWork: 'Jak s Učíme.se nejlépe pracovat?',
    openSupport: 'Otevřít návody',

  },
  sk: {
    projectTitle: 'Učíme.se',
    login: 'Prihlásenie',
    loginAction: 'Prihlásiť',
    email: 'E-mail',
    name: 'Meno',
    close: 'Zavrieť',
    create: 'Vytvoriť',
    refresh: 'Obnoviť',
    error: 'Vyskytla sa chyba, skúste neskôr.',
    registration: 'Registrácia učiteľa',
    registrationAction: 'Registrovať',
    moveBack: 'Späť na',
    nameSurname: 'Meno a priezvisko',
    school: 'Název školy',
    send: 'Odoslať',
    fillName: 'Vyplň meno a priezvisko',
    password: 'Heslo',
    introEntry: 'Potvrdiť',
    userNotExist: 'Užívateľ neexistuje',
    noAccount: 'Nemáte ešte účet?',
    alertInvalidPassword: 'Nesprávné heslo',
    passwordValidation: 'Heslo je príliš krátké, musí obsahovať aspoň 8 znakov',
    files: 'Súbory',
    filesAdd: 'Nahrať súbor',
    filesUrl: 'Odkazy',
    filesAddUrl: '+ pridať odkaz (Youtube, Google dokumenty, ...)',
    filesFillUrl: 'Vyplňte URL adresu odkazu',
    filesMaxSize: 'Maximálna veľkosť súboru je 10MB',
    filesAlertPdf: 'Zatiaľ podporujeme iba obrázkové a PDF formáty. Súbory je možné žiakom naživo premietať počas vyučovania.',
    filetypeNotAllowed: 'Tento typ súboru zatiaľ nie je podporovaný',
    fileUploadFailed: 'Nahrávanie súborů zlyhalo.',
    emailRequired: 'E-mail je povinný',
    emailNotExist: 'Účet s týmto e-mailom neexistuje',
    emailValid: 'E-mail musí byť v platnom formáte',
    emailRegistred: 'E-mail je už zaregistrovaný',
    conditions: 'Pre pokračovanie je nutný súhlas s podmienkami',
    conditionsButtonAgree: 'Súhlasím s',
    conditionsButtonCond: 'obchodnými podmienkami',
    conditionsLink: 'https://uploads-ssl.webflow.com/5e823696f1510536760ddea1/5e8348dd35019b6937c74a41_Obchodne%CC%81%20podmie%CC%81nky.pdf',
    futureEvents: 'Naplánované',
    forgotPassword: 'Zabudnuté heslo',
    forgotPasswordText: 'Odkaz na obnovenie hesla nájdete v e-maili',
    forgotPasswordLogin: 'Nepamätáte si heslo?',
    forgotPasswordQuestion: 'Zabudli ste heslo?',
    lessonTitle: 'Vyučovanie',
    lessonList: 'Zoznam vyučovaní',
    lessonStart: 'Začať výučbu',
    lessonEmpty: 'Momentálne nemáte<br>naplánovanú žiadnu výučbu',
    lessonDialogTitle: 'Vytváranie online výučby',
    lessonDialogPlaceholder: 'Názov výučby (napr. Dejepis)',
    lessonDialogDate: 'Dátum',
    lessonDialogTime: 'Začiatok o',
    lessonDialogTimeHint: 'Vo formáte HH:mm',
    lessonDialogStudents: 'E-maily žiakov (oddelené čiarkou)',
    lessonDialogStudentsHint: 'Maximálne 35 žiakov',
    lessonDialogAbout: 'Vytvorením výučby sa žiakom automaticky odošle informačný email.',
    lessonDialogAboutLink: 'Po tvorbe výučby získate odkaz, ktorý so svojimi žiakmi sami nazdieľate.',
    lessonCreate: 'Vytvoriť výučbu',
    lessonHistory: 'História',
    alertLessonTitle: 'Vyplňte názov výučby',
    alertLessonDate: 'Vyplňte dátum',
    alertLessonTime: 'Vyplňte čas',
    alertLessonEmail: 'Vyplňte e-maily',
    online: 'online',
    offline: 'offline',
    activeInVideo: 'aktívny vo videu',
    videoEnd: 'Vrátiť',
    videoConnect: 'Vyvolať',
    statusOnline: 'Zatiaľ nie je nikto online',
    statusOffline: '<strong>Všetci sú online!</strong><br />Tak tomu sa hovorí morálka!',
    buttonTextLessonStart: 'Začať vyučovanie',
    buttonTextLessonEnd: 'Ukončit vyučovanie',
    buttonTextEnd: 'Koniec',
    students: 'Žiaci',
    cameraOff: 'Video je k dispozícii len počas výučby',
    keynoteOff: 'Momentálne tu nie je žiadna prezentácia',
    waveHand: '👋 Zdvihnúť ruku',
    wavingHand: '👋 Zdvihnutá ruka',
    teacherMulti: 'Učiteľ/ka',
    notSelected: '(bez prezentácie)',
    linkUnavaliable: 'Limit počtu žiakov bol dosiahnutý',
    done: 'Dokončiť',
    continue: 'Pokračovať',
    enter: 'Vstúpiť',
    filesToBeUsed: 'Materiály, s ktorými budete pracovať',
    optional: '(Nepovinné - môžete doplniť neskôr)',
    browserInfo: 'Pre plnú funkcionalitu Učíme.se používajte prosím jeden z nasledujúcich prehliadačov: <a href="https://www.google.com/intl/cs_CZ/chrome/" target="_blank"><strong>Chrome</strong><a/>, Firefox alebo Opera.',
    support: 'Podpora',
    recycle: 'Použiť znova',
    deteleTitle: 'Zmazať výučbu',
    deteleSubtitle: 'Po potvrdení dôjde k úplnému zmazaniu. Žiaci nebudú mať viac prístup k tejto výučbe.',
    dialogCancel: 'Zrušiť',
    dialogDelete: 'Zmazať',
    toggleVideo: 'Vypnúť / Zapnúť video',
    toggleAudio: 'Vypnúť / Zapnúť zvuk',
    download: 'Stiahnuť',
    inYourHands: 'Je to vo Vašich rukách',
    whatCanWeImprove: 'Čo môžeme v budúcnosti zlepšiť?',
    howDoYouRate: 'Ako hodnotíte túto výučbu?',
    howDoYouRateTest: 'Ako zatiaľ hodnotíte Učíme.se?',
    justFinishedLesson: 'Práve sme s mojimi žiakmi absolvovali hodinu cez Učíme se. Kolegovia, odporúčam vyskúšať!',
    toolForLearning: 'Nástroj pre online výučbu',
    shareViaEmail: 'Zdieľať e-mailom',
    shareViaFacebook: 'Zdieľať na Facebooku',
    helpToShare: 'Pomôžte nám Učíme se dostať medzi svojich kolegov',
    yourMessage: 'Vaša správa',
    somethingWentWrong: 'Žiadna sláva',
    fineBut: 'Fajn, ale...',
    amazing: 'Super',
    viewWindowType1: 'Pomer okien 1: 1',
    viewWindowType2: 'Veľké video',
    viewWindowType3: 'Veľká prezentácia',
    openLink: 'Otvoriť odkaz',
    chat: 'Chat',
    shareScreen: 'Zdieľanie obrazovky',
    media: 'Materiály',
    keynotePrev: 'Predchádzajúca strana',
    keynoteNext: 'Ďalšia strana',
    studentInvite: 'Odkaz na výučbu',
    linkCopySubheadline: 'Cez tento odkaz sa Vaši žiaci dostanú k online výučbe.',
    copyLink: 'Skopírovať odkaz',
    copiedLink: 'Odkaz bol skopírovaný',
    copyLinkExtended: 'Skopírovať odkaz na výučbu',
    voiceless: 'Bez mikrofónu',
    noMicButHears: 'Žiak však môže výučbu pozorovať',
    iWillInvite: 'Žiakov pozvem vlastnou cestou (WhatsApp, Google Classroom, ...)',
    howToWork: 'Ako s Učíme.se najlepšie pracovať?',
    openSupport: 'Otvoriť návody',


  },
};
export default messages;
